import { jwtDecode } from "jwt-decode";

const AUTH_TOKEN_KEY = "auth_token";
const AUTH_USER_KEY = "auth_user";
export const AUTH_SESSION_CHANGED_EVENT = "auth-session-changed";

const notifyAuthSessionChanged = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(AUTH_SESSION_CHANGED_EVENT));
  }
};

const decodeTokenPayload = (token) => {
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

export const isAuthTokenExpired = (token) => {
  if (!token) {
    return true;
  }

  const payload = decodeTokenPayload(token);
  const expiryTime = Number(payload?.exp);
  if (!Number.isFinite(expiryTime)) {
    return true;
  }

  return Math.floor(Date.now() / 1000) >= expiryTime;
};

export const getAuthToken = () => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY) || "";
  if (!token) {
    return "";
  }

  if (isAuthTokenExpired(token)) {
    clearAuthSession();
    return "";
  }

  return token;
};

export const getStoredUser = () => {
  const user = localStorage.getItem(AUTH_USER_KEY);
  if (!user) {
    return null;
  }

  try {
    return JSON.parse(user);
  } catch {
    return null;
  }
};

export const saveAuthSession = (token, user) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
  notifyAuthSessionChanged();
};

export const clearAuthSession = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  notifyAuthSessionChanged();
};
